import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * PageHeader Component
 *
 * Displays a page title with gradient underline, optional subtitle,
 * and a refresh button with spinning animation during data fetching.
 *
 * @example
 * ```tsx
 * <PageHeader
 *   title="Dashboard"
 *   subtitle="Company-wide commission overview"
 *   onRefresh={() => refetchData()}
 *   isRefreshing={loading}
 * />
 * ```
 */
export const PageHeader = ({ title, subtitle, onRefresh, isRefreshing = false, actions, className = '', }) => {
    return (_jsxs("div", { className: `mb-6 ${className}`, children: [_jsxs("div", { className: "flex items-start justify-between", children: [_jsx("div", { className: "flex-1", children: _jsx("h1", { className: "text-2xl font-bold text-white", children: title }) }), _jsxs("div", { className: "flex items-center gap-3", children: [actions, onRefresh && (_jsx("button", { onClick: onRefresh, disabled: isRefreshing, className: "p-2 rounded-lg bg-white/5 hover:bg-white/10 text-slate-400 hover:text-white transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed", title: "Refresh data", children: _jsx("svg", { className: `w-5 h-5 ${isRefreshing ? 'animate-spin' : ''}`, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" }) }) }))] })] }), _jsx("div", { className: "gradient-underline mt-3" }), subtitle && (_jsx("p", { className: "text-sm text-slate-400 mt-2", children: subtitle }))] }));
};
export default PageHeader;
